<template>
  <b-card body-class="terminal-body" header-class="terminal-header">
    <template #header>
      <div class="text-center">لاگ‌های سرویس</div>
    </template>
    <vue-custom-scrollbar class="scroll-area">
      <p v-for="(log, i) in logs" :key="i">{{ log.trim() }}</p>
    </vue-custom-scrollbar>
  </b-card>
</template>

<script>
import { userServiceLogs } from "@/services/service";
import vueCustomScrollbar from "vue-custom-scrollbar";
export default {
  name: "AppLogs",
  components: {
    vueCustomScrollbar
  },
  data() {
    return {
      serviceId: this.$route.params.serviceId,
      settings: {
        wheelPropagation: false
      },
      logs: "",
      counter: 0,
      timerInterval: null
    };
  },
  mounted() {
    this.getLogs();
    this.timerInterval = setInterval(this.timer, 10000);
  },
  methods: {
    timer: function() {
      this.getLogs();
    },
    getLogs: async function() {
      const [error, data] = await userServiceLogs(this.$route.params.serviceId);
      if (!error) {
        if (data.apiStatus === 200) {
          this.logs = data.apiData.logs.split("\n");
        } else {
          console.log(data.apiErrors);
        }
      }
    }
  },
  destroyed() {
    clearInterval(this.timerInterval);
  }
};
</script>

<style lang="scss">
.terminal-header {
  position: relative;
  padding: 5px;
  &-icon {
    direction: ltr;
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;

    & .btn {
      margin-left: 10px;
      padding: 5px;
      display: flex;
      align-items: center;
    }
  }
}
.terminal-body {
  height: calc(100vh - 200px);
  direction: ltr;
  text-align: left;
  background-color: rgb(19, 19, 19);
  color: #fff;
  font-family: "Courier New", Courier, monospace;
}
</style>
